// extracted by mini-css-extract-plugin
export var PageScrollStatus = "page-scroll-status-module--PageScrollStatus--3EG8k";
export var PageScrollStatus__status = "page-scroll-status-module--PageScrollStatus__status--3zWpg";